<template>
  <div v-if="rule.content" class="theme-banner-rule" :class="{ 'theme-banner-rule-active' : isClick }" :style="ruleStyle" @click="ruleClick">
    <div class="position-relative">
      <div class="theme-banner-rule-txt position-center" v-text="rule.title" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rule: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isClick: false
    };
  },
  computed: {
    ruleStyle() {
      let style = `width: ${this.rule.title.length * 0.32 + 0.60}rem;`;
      if (this?.rule?.backgroundColor) {
        style += `background-color: ${this.rule.backgroundColor};`
      }
      if (this?.rule?.fontColor) {
        style += `color: ${this.rule.fontColor};`
      }
      return style;
    }
  },
  methods: {
    timeout(callback) {
      const timeout = setTimeout(() => {
        clearTimeout(timeout);
        callback();
      }, 100);
      return timeout;
    },
    //  按钮点击效果控制
    buttonEffect(callback) {
      this.isClick = true;
      this.timeout(() => {
        this.isClick = false;
        this.timeout(() => callback());
      });
    },
    //  点击按钮
    ruleClick() {
      this.buttonEffect(() => {
        const sheetConfig = {
          msg: this.rule.content.replace(/\n/g, '</br>'),
          title: this.rule.title
        };
        console.log('sheetConfig: ', sheetConfig)
        Vue.filter("current-action-sheet")(true, sheetConfig)
      });
    }
  }
}
</script>

<style lang="stylus" scoped>
  .theme-banner-rule {
    position: absolute;
    top: 20px;
    right: 0;
    background-color: rgba(0, 0, 0, .6);
    height: 26px;
    border-radius: 13px 0px 0px 13px;
    white-space: nowrap;
    transition: all .3s;
    z-index 1
    color: #fff;
  }
  .theme-banner-rule-active {
    background-color: rgba(0, 0, 0, 1);
  }
  .theme-banner-rule-txt {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }
</style>
